import styled from '@emotion/styled';
import { breakpoints, spacing, borderRadius } from '@naf/theme';
import { Typography } from '@naf-simba/building-blocks-typography';
import { nafColor } from '@nafcore/theme';

interface LayoutProps {
  $isFullWidth: boolean;
}

export const AppBannerWrapper = styled.div<LayoutProps>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    'content content'
    'image store';
  gap: ${spacing.space24} ${spacing.space16};
  background-color: ${nafColor.signature.yellow20};
  padding: ${spacing.space24};
  border-radius: ${borderRadius.L};
  margin-bottom: ${spacing.space32};
  min-width: 0;

  ${({ $isFullWidth }) =>
    $isFullWidth &&
    `
      @media (min-width: ${breakpoints.m}) {
        grid-template-columns: 200px minmax(0, 1fr) max-content;
        grid-template-areas: 'image content store';
        gap: ${spacing.space24};
        align-items: center;
        padding: ${spacing.space24} ${spacing.space32};
      }
    `}
`;

export const AppImageWrapper = styled.div<LayoutProps>`
  grid-area: image;
  position: relative;
  min-width: 0;
  height: 192px;

  ${({ $isFullWidth }) =>
    $isFullWidth &&
    `
      @media (min-width: ${breakpoints.m}) {
        height: 120px;
      }
    `}
`;

export const PhoneImage = styled.img<LayoutProps>`
  position: absolute;
  left: -40px;
  bottom: -56px;
  display: block;
  max-width: none;
  height: auto;
  object-fit: contain;

  ${({ $isFullWidth }) =>
    $isFullWidth &&
    `
      @media (min-width: ${breakpoints.m}) {
        top: 50%;
        bottom: auto;
        left: -16px;
        transform: translateY(-50%);
      }
    `}
`;

export const AppContentWrapper = styled.div`
  grid-area: content;
  display: flex;
  flex-direction: column;
  gap: ${spacing.space8};
  min-width: 0;
  overflow-wrap: break-word;
`;

export const Title = styled(Typography)`
  && {
    margin: 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
`;

export const SubTitle = styled(Typography)`
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const IconText = styled(Typography)`
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const IconTextWrapper = styled.div`
  margin-bottom: ${spacing.space16};
`;

export const IconTextRow = styled.div`
  display: flex;
  gap: ${spacing.space8};
  align-items: flex-start;
  margin-bottom: ${spacing.space8};

  p {
    margin: 0 !important;
  }

  svg {
    color: ${nafColor.information.successDark};
    flex-shrink: 0;
  }
`;

export const StoreLinks = styled.div`
  grid-area: store;
  display: flex;
  flex-direction: column;
  gap: ${spacing.space12};
  align-items: flex-end;
  justify-content: flex-end;
  min-width: 0;
`;

export const StoreLink = styled.a`
  display: block;
  width: 140px;
  max-width: 100%;
`;

export const StoreImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;
